import { useMemo } from 'react';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';

import { MessageEditState } from './message-edit-state';
import { MessageStatusConfigurator } from './message-status-configurator';

import { useTriggeredMessage } from '../../hooks/use-triggered-message.hook';
import { PAGE_TITLE } from '../triggered-message-edit.constants';
import { useSubBrandByUuid } from '../../hooks/use-sub-brand-by-uuid.hook';
import { getEditLinks } from '../../triggered-messages.utils';

type MessageUpdateProps = {
  messageId: string;
  scope?: string;
};

export const MessageUpdate = (props: MessageUpdateProps) => {
  const { scope, messageId } = props;

  const { data: triggeredMessage, loading } = useTriggeredMessage(messageId);
  const subBrand = useSubBrandByUuid(scope);
  useAppLayoutContextConsumer(
    useMemo(() => getEditLinks(triggeredMessage, subBrand).links, [subBrand, triggeredMessage]),
  );

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: triggeredMessage?.description || PAGE_TITLE,
        status: triggeredMessage ? (
          <MessageStatusConfigurator message={triggeredMessage} />
        ) : undefined,
      }}
      containerProps={{ variant: 'md' }}
    >
      <MessageEditState message={triggeredMessage} loading={loading} subBrand={subBrand} />
    </Page>
  );
};
